"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cached = exports.minutes = exports.seconds = void 0;
const cache_1 = require("@ledgerhq/live-network/cache");
const object_hash_1 = __importDefault(require("object-hash"));
function seconds(num, max = 100) {
    return {
        max,
        ttl: num * 1000,
    };
}
exports.seconds = seconds;
function minutes(num, max = 100) {
    return seconds(num * 60, max);
}
exports.minutes = minutes;
const cacheKeyAddress = (address) => address;
const cacheKeyEmpty = () => "";
const cacheKeyAssocTokenAccAddress = (owner, mint) => `${owner}:${mint}`;
const cacheKeyMinimumBalanceForRentExemption = (dataLengt) => dataLengt.toString();
const cacheKeyTransactions = (signatures) => (0, object_hash_1.default)([...signatures].sort());
const cacheKeyByArgs = (...args) => (0, object_hash_1.default)(args);
function cached(api) {
    return {
        findAssocTokenAccAddress: (0, cache_1.makeLRUCache)(api.findAssocTokenAccAddress, cacheKeyAssocTokenAccAddress, minutes(1000)),
        getAccountInfo: (0, cache_1.makeLRUCache)(api.getAccountInfo, cacheKeyAddress, seconds(30)),
        getAssocTokenAccMinNativeBalance: (0, cache_1.makeLRUCache)(api.getAssocTokenAccMinNativeBalance, cacheKeyEmpty, minutes(5)),
        getBalance: (0, cache_1.makeLRUCache)(api.getBalance, cacheKeyAddress, seconds(30)),
        getBalanceAndContext: (0, cache_1.makeLRUCache)(api.getBalanceAndContext, cacheKeyAddress, seconds(30)),
        getParsedTransactions: (0, cache_1.makeLRUCache)(api.getParsedTransactions, cacheKeyTransactions, seconds(30)),
        getParsedTokenAccountsByOwner: (0, cache_1.makeLRUCache)(api.getParsedTokenAccountsByOwner, cacheKeyAddress, minutes(1)),
        getStakeAccountsByStakeAuth: (0, cache_1.makeLRUCache)(api.getStakeAccountsByStakeAuth, cacheKeyAddress, minutes(1)),
        getStakeAccountsByWithdrawAuth: (0, cache_1.makeLRUCache)(api.getStakeAccountsByWithdrawAuth, cacheKeyAddress, minutes(1)),
        getStakeActivation: (0, cache_1.makeLRUCache)(api.getStakeActivation, cacheKeyAddress, minutes(1)),
        getInflationReward: (0, cache_1.makeLRUCache)(api.getInflationReward, cacheKeyByArgs, minutes(5)),
        getVoteAccounts: (0, cache_1.makeLRUCache)(api.getVoteAccounts, cacheKeyEmpty, minutes(1)),
        getLatestBlockhash: (0, cache_1.makeLRUCache)(api.getLatestBlockhash, cacheKeyEmpty, seconds(15)),
        getFeeForMessage: (0, cache_1.makeLRUCache)(api.getFeeForMessage, msg => msg.serialize().toString(), minutes(1)),
        getSignaturesForAddress: (0, cache_1.makeLRUCache)(api.getSignaturesForAddress, cacheKeyByArgs, seconds(30)),
        getMinimumBalanceForRentExemption: (0, cache_1.makeLRUCache)(api.getMinimumBalanceForRentExemption, cacheKeyMinimumBalanceForRentExemption, minutes(5)),
        // do not cache
        sendRawTransaction: api.sendRawTransaction,
        getEpochInfo: (0, cache_1.makeLRUCache)(api.getEpochInfo, cacheKeyEmpty, minutes(1)),
        config: api.config,
    };
}
exports.cached = cached;
//# sourceMappingURL=cached.js.map